import networkService from '../Network/NetworkManager';
import {fetch_all_categories} from '../utils/fetch_all_categories';
const APPURL = require('../Constants/URLConstants');

//

export const getAllAccounts = async ({}) => {
  const responseJson = await networkService.networkCall(
    APPURL.URLPaths.accounts + `?page=1&per_page=100&type=accounts`,
    'get',
    '',
    '',
  );

  if (responseJson['status'] == true) {
    var list = responseJson['data']['accounts'];
    return list;
  } else {
    return [];
  }
};
